import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { SearchService } from "../services/search-service";
import { NotifyService } from "../services/notify-service";
export function DashboardSearch(): ng.IDirective {
    return {
        restrict: 'E',
        template: require("/assets/app/templates/dashboard-search.html"),
        controller: DashboardSearchController,
        bindToController: true,
        controllerAs: 'dbsVM',
        scope: {
            search: '='
        }
    }
}

export class DashboardSearchController {
    static $inject = ['$scope', '$window', '$timeout', 'searchService', 'notifyService', 'charTypeIcons'];
    search: Models.ISaveSearchModel;
    page: number;
    numFound: number;
    pageCount: number;
    itemRows: Models.IEntitySearchDoc[];
    rowCount: number;
    initialized: boolean;

    constructor(
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $timeout: ng.ITimeoutService,
        private searchService: SearchService,
        private notifyService: NotifyService,
        private charTypeIcons: any) {

        this.itemRows = [];
        this.page = 1;
        this.initialized = false;

        $scope.$watch(() => this.page, (newValue, oldValue) => {
            if (newValue && oldValue && newValue !== oldValue) {
                this.Search();
            }
        });

        $scope.$watch(() => this.search.searchRequest.rowCount, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.Search();
            }
        });

        $scope.$watch(() => this.search, (newValue) => {
            if (this.itemRows.length === 0) {
                this.Search();
            }
        });
    }

    Search() {
        this.rowCount = this.search.searchRequest.rowCount;
        this.search.searchRequest.page = this.page;

        this.notifyService.startProgress();
        this.searchService.advancedSearch(this.search.searchRequest)
            .then((res) => {
                this.itemRows = res.documents;
                this.pageCount = Math.ceil(res.numFound / this.rowCount);
                this.numFound = res.numFound;
            })
            .finally(() => {
                this.initialized = true;
                this.notifyService.endProgress();
            });
    }

    RemoveSearch() {
        if (this.$window.confirm("Are you sure you want to remove the " + this.search.name + " search from your dashboard?")) {
            this.search.showOnDashboard = false;
            this.searchService.saveSearch(this.search);
            this.$timeout(() => {
                this.$window.location.reload();
            }, 100, false);
        }
    }

    GetCharTypeIcon(charTypeId: number) {
        for (var i = 0; i < this.charTypeIcons.length; i++) {
            var ct = this.charTypeIcons[i];
            if (ct.charTypeID == charTypeId) {
                return ct.class;
            }
        }
    }
}
